/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type DescriptionCell_ConfigurationFragment = { __typename: 'ConfigurationModel', id: string, description?: string | null };

export const DescriptionCell_ConfigurationFragmentDoc = gql`
    fragment DescriptionCell_configuration on ConfigurationModel {
  id
  description
}
    `;